import { render, staticRenderFns } from "./TabelaResultadosServidores.vue?vue&type=template&id=9b2a2394&scoped=true&"
import script from "./TabelaResultadosServidores.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosServidores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2a2394",
  null
  
)

export default component.exports